
import api from './../api';

class UploadFilesService {

  upload(file, projectId, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);
    formData.append("project_id", projectId);

    return api.post("/upload_file", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }

  // Upload with threading
  uploadThreading(file, projectId, onUploadProgress) {
    let formData = new FormData();

    formData.append("file", file);
    if (projectId) {
      formData.append("project_id", projectId);
    }

    return api.post("/upload_file_threading", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
    });
  }

  // Check if file already exists
  checkDuplicate(file, projectId) {
    const formData = new FormData();
    formData.append('file', file);
    if (projectId) {
      formData.append('project_id', projectId);
    }

    return api.post("/check_duplicate", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      }
    });
  }

  // Rename and upload a file
  renameAndUpload(tempPath, newFilename, projectId) {
    return api.post("/confirm_upload", {
      action: 'rename',
      file_path: tempPath,
      new_filename: newFilename,
      project_id: projectId
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  // Overwrite an existing file
  overwriteAndUpload(tempPath, filename, projectId) {
    return api.post("/confirm_upload", {
      action: 'overwrite',
      file_path: tempPath,
      filename: filename,
      project_id: projectId
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }
  uploadFromUrl(url, projectId) {
    return api.post("/upload-from-url", { url, project_id: projectId });
  }

  getFiles() {
    return api.get('/user_files');
  }

  getFileStatus(fileId) {
    return api.get(`/file_status/${fileId}`);
  }

}

export default new UploadFilesService();